import './Stream.css'
import { ContainerWraper, Title, LargeCard, PrimaryButton, TopStreamCard, SildeCard } from '../../component';
import TopStreamData, { MostPopularStreamData } from './../../sections/Data/StreamData';

const TopGame = TopStreamData.map(p => {
    return <TopStreamCard image={p.image} name={p.name} />
});

const Largecard = MostPopularStreamData.map(p => {
    return <LargeCard image={p.image} profile={p.profile} caption={p.caption} detail={p.detail} />
});

const Stream = () => {
    return (
        <>
            <div className='row' style={{ padding: "0" }}>
                <div className='col-lg-8'>
                    <div>
                        <ContainerWraper class={`mt-0`}>
                        <Title first="Live" last="Streams" />
                            <SildeCard />
                        </ContainerWraper>
                    </div>
                </div >
                < div className='col-lg-4' >
                    <ContainerWraper class={`mt-0`}>
                        <Title first="Top" last="Streams" />
                        {TopGame}
                    </ContainerWraper>
                </div >
            </div >
            <div className='row'>
                <ContainerWraper >
                    <Title first="Most Popular " last="Live Stream" />
                    <div className='row'>
                        {Largecard}
                        <div className='brows-btn'>
                            <PrimaryButton>
                                Descover AllStream
                            </PrimaryButton>
                        </div>
                    </div>
                </ContainerWraper>
            </div>
        </ >
    )
}

export default Stream